import { render, staticRenderFns } from "./CouriersTable.vue?vue&type=template&id=2234db06"
import script from "./CouriersTable.vue?vue&type=script&lang=js"
export * from "./CouriersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports